import { render, staticRenderFns } from "./api-test.vue?vue&type=template&id=9baaa314&scoped=true"
import script from "./api-test.vue?vue&type=script&lang=js"
export * from "./api-test.vue?vue&type=script&lang=js"
import style0 from "./api-test.vue?vue&type=style&index=0&id=9baaa314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9baaa314",
  null
  
)

export default component.exports